<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { ref } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import SmartDetailedJobFooterBtnMenuVList from '@/components/vLists/SmartDetailedJobFooterBtnMenuVList.vue';
import { fetchGetJobResync } from '@/helpers/fetchers';

export interface Props {
  job?: ReadonlyDeep<
    Pick<
      openapi.JobDetailedOpenapi,
      'current_driver_code' | 'rockhopper_date' | 'rockhopper_id'
    >
  >;
  openNewTicketDialog?: () => void;
  openNewQueryDialog?: () => void;
  openSplitToBaseDialog?: () => void;
  refreshDetailedJob?: () => Promise<void>;
}
const props = withDefaults(defineProps<Props>(), {
  job: undefined,
  openNewTicketDialog: undefined,
  openNewQueryDialog: undefined,
  openSplitToBaseDialog: undefined,
  refreshDetailedJob: undefined,
});

const isFetching = ref(false);

const isMenuOpen = ref(false);

function closeMenu(): void {
  isMenuOpen.value = false;
}

async function resync(): Promise<void> {
  if (!props.job) return;
  if (isFetching.value) return;
  isFetching.value = true;
  await fetchGetJobResync({
    job_id: props.job.rockhopper_id,
    job_date: props.job.rockhopper_date,
  })
    .then(async () => {
      if (props.refreshDetailedJob) {
        await props.refreshDetailedJob();
      }
    })
    .finally(() => {
      isFetching.value = false;
    });
}
</script>

<template>
  <v-menu
    v-model="isMenuOpen"
    :close-on-content-click="false"
    :persistent="isFetching"
    :class="$style.detailedJobFooterVMenu"
    data-testid="detailedJobFooterVMenu"
  >
    <template #activator="{ props: menuProps }">
      <KBtn
        v-bind="menuProps"
        size="lg"
        append-icon="mdi-chevron-down"
        :disabled="false"
        :loading="false"
        @click="false"
      >
        Change job status
      </KBtn>
    </template>
    <SmartDetailedJobFooterBtnMenuVList
      :job="props.job"
      :open-new-ticket-dialog="openNewTicketDialog"
      :open-new-query-dialog="openNewQueryDialog"
      :open-split-to-base-dialog="openSplitToBaseDialog"
      :close-menu="closeMenu"
      :resync="resync"
    />
  </v-menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobFooterVMenu {
}
  .btn {
    text-transform: none;
  }
</style>
